import Main from './CompanyServicesMain'
import New from './CompanyServicesNew'
import Edit from './CompanyServicesEdit'
import Show from './CompanyServicesShow'

const companyService = { Main, New, Edit, Show }

export default companyService
